import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SyndicatesState } from './syndicates.model';

// Feature selector
export const selectSyndicatesState = createFeatureSelector<SyndicatesState>('syndicates');

// List related selectors
export const selectList = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.list
);

export const selectWinList = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.wins_list
);

export const selectHomeList = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.home_list
);

export const selectFilters = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.list_pagination
);

// Single syndicate related selectors
export const selectSyndicate = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.portion
);

// Join status selectors
export const selectSyndicateJoinSuccess = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.joinSuccess
);

export const selectSyndicateJoinError = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.joinError
);

// Loading state selectors
export const selectSyndicateLoading = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.isLoading
);

export const selectSingleSyndicateLoading = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.syndicateIsLoading
);

// Commentary related selectors
export const selectCommentaryStatus = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.commentaryStatus
);

export const selectCommentaryList = createSelector(
  selectSyndicatesState,
  (state: SyndicatesState) => state.comments
);

export const selectTopSquads = createSelector(selectSyndicatesState, (state: SyndicatesState) => state.topSquads);
